var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opera-btn-group",class:{up:!_vm.showSearch}},[_c('div',{staticClass:"opera-icon"},[_c('span',{staticClass:"pull-right"},[_c('des-btn',{attrs:{"perm":_vm.perm.add,"custom":"","icon":"plus"},on:{"click":_vm.add}},[_vm._v("添加")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }